const { default: axios } = require("axios");
const Swal  = require('sweetalert2');

const ModalDetails = function () {

    const callAjax = (e) => {

        // console.log('carregou click')

        const _this = $(e.currentTarget);
        var urlAjax = _this.attr('data-call-ajax');
        var typeCall = _this.attr('data-showlayermodal');

        // console.log(typeCall);
        if( typeCall == 'modal-ajax' ) {

            $("#mdl-result-ajax").html("");
            $("#spinner-loading-modal").fadeIn(100);

        } else {
            Swal.fire({
                title: 'Por favor, Aguarde...',
                allowOutsideClick: false,
                showCancelButton: false,
                showCloseButton: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });    
        }

        console.log(urlAjax);

        axios.get(urlAjax)
            .then(function (response) {
                //console.log(response.data);
                //const data = response.data;

                Swal.close();

                $("#spinner-loading-modal").fadeOut(200);

                //if (response.data.error == false) {

                    if (response.data.message) {
                        $("#mdl-result-ajax").html('<h2>'+response.data.message+'</h2>');
                    } else {
                        $("#mdl-result-ajax").html(response.data);
                    }      
                    
                    const _modalMedidas = $("#medidas-cols"); 
                    if(_modalMedidas.length > 0){
                        if(_modalMedidas.find('.modal-text').length > 40){
                            _modalMedidas.addClass('columns-divide');
                        }
                    }
                    
            });

        e.preventDefault();

    }

    return {
        init : () => {
            $(document).on('click', '.link-call-ajax', callAjax);
        }
    }

}();

export default ModalDetails;